import axios from 'axios'
import router from '@/router'
import { ElMessage } from 'element-plus'
import i18n from '@/i18n'

// 创建axios实例
const service = axios.create({
  baseURL: '/api',
  timeout: 300000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从localStorage获取token
    const token = localStorage.getItem('admin_token')
    if (token) {
      config.headers['satoken'] = token
    }
    
    return config
  },
  error => {
    console.error('请求错误：', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 文件下载等 blob 响应：直接返回 body，不解析 code
    if (response.config.responseType === 'blob') {
      if (response.status === 200) return response.data
      return Promise.reject(new Error('Download failed'))
    }

    const res = response.data
    
    // 如果返回的状态码不是200，说明接口请求有误
    if (res.code !== 200) {
      // 401未授权，需要区分是登录接口还是其他接口
      if (res.code === 401) {
        const requestUrl = response.config.url
        // 如果是登录接口，不在这里处理，让业务代码自己处理
        if (requestUrl === '/auth/login' || requestUrl === '/api/auth/login') {
          // 登录接口的401错误，由业务代码处理，不显示"登录已过期"
          // 注意：error.message 使用国际化消息，而不是后端返回的中文消息
          const error = new Error(i18n.global.t('message.usernameOrPasswordError'))
          error.code = res.code
          error.response = { data: res }
          return Promise.reject(error)
        } else {
          // 其他接口的401错误，表示登录已过期
          ElMessage.error(i18n.global.t('message.loginExpired'))
          localStorage.removeItem('admin_token')
          localStorage.removeItem('admin_user')
          router.push('/login')
          // 注意：error.message 使用国际化消息
          const error = new Error(i18n.global.t('message.loginExpired'))
          error.code = res.code
          error.response = { data: res }
          return Promise.reject(error)
        }
      }
      
      // 其他错误，不显示消息（由具体业务代码处理）
      // 创建一个包含 code 的错误对象，确保业务代码能获取到错误码
      // 注意：不设置 error.message，让业务代码根据 code 显示国际化消息
      const error = new Error('Request failed')
      error.code = res.code
      error.response = { data: res }
      return Promise.reject(error)
    }
    
    // 登录成功，保存token
    // 注意：由于 pathRewrite 去掉了 /api 前缀，实际请求路径是 /auth/login
    if ((response.config.url === '/auth/login' || response.config.url === '/api/auth/login') && res.data && res.data.token) {
      localStorage.setItem('admin_token', res.data.token)
      if (res.data.user) {
        localStorage.setItem('admin_user', JSON.stringify(res.data.user))
      }
    }
    
    return res
  },
  error => {
    console.error('响应错误：', error)
    
    // 401未授权，跳转到登录页
    if (error.response && error.response.status === 401) {
      ElMessage.error(i18n.global.t('message.loginExpired'))
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_user')
      router.push('/login')
    } else {
      // 其他错误不在这里统一处理，由具体业务代码处理
      // const message = error.response?.data?.message || error.message || '请求失败'
      // ElMessage.error(message)
    }
    
    return Promise.reject(error)
  }
)

export default service

